var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDemoRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 218,
    viewBox: "0 0 239 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 34.199c0-19.33-16.088-34.915-35.643-34.174-17.386.66-31.716 14.493-32.895 31.793-.75 10.993 3.718 20.969 11.18 27.716V44.928h46.097v14.606C234.658 53.277 239 44.244 239 34.199Z",
    fill: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.474 44.28v136.506H.006v-5.572H0V44.244h123.527v.037h103.947Z",
    fill: "#3585F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.285 190.303H.208m113.539 0v26.603m-27.665.001h55.02m86.183-26.604H.208m113.539 0v26.603m-27.665.001h55.02",
    stroke: "#020202",
    strokeWidth: 3.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.853 161.582a2.976 2.976 0 0 0 2.981-2.971 2.976 2.976 0 0 0-2.981-2.971 2.976 2.976 0 0 0-2.981 2.971 2.976 2.976 0 0 0 2.981 2.971Zm10.12-2.833a2.976 2.976 0 0 0 2.981-2.971 2.976 2.976 0 0 0-2.981-2.971 2.975 2.975 0 0 0-2.98 2.971 2.975 2.975 0 0 0 2.98 2.971Zm9.472-5.39a2.977 2.977 0 0 0 2.981-2.972 2.976 2.976 0 0 0-2.981-2.971 2.976 2.976 0 0 0-2.981 2.971 2.977 2.977 0 0 0 2.981 2.972Zm7.278-7.57a2.976 2.976 0 0 0 2.981-2.971 2.976 2.976 0 0 0-2.981-2.971 2.975 2.975 0 0 0-2.98 2.971 2.975 2.975 0 0 0 2.98 2.971Zm5.407-9.435a2.976 2.976 0 0 0 2.981-2.972 2.976 2.976 0 0 0-2.981-2.971 2.975 2.975 0 0 0-2.98 2.971 2.976 2.976 0 0 0 2.98 2.972Zm2.811-10.686a2.976 2.976 0 0 0 2.981-2.971 2.976 2.976 0 0 0-2.981-2.971 2.976 2.976 0 0 0-2.981 2.971 2.976 2.976 0 0 0 2.981 2.971Zm-26.423-65.463h-27.879v7.47h27.879v-7.47Zm28.435 20.167-9.661-9.63-5.298 5.282 9.661 9.63 5.298-5.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.591 86.665 7.877-7.853-5.293-5.277-8.136 8.11a44.837 44.837 0 0 0-27.286-9.203c-24.817 0-44.938 20.058-44.938 44.796s19.56 44.231 43.898 44.784v-5.811c-21.123-.553-38.075-17.79-38.075-38.973 0-21.182 17.512-38.991 39.115-38.991 21.602 0 38.371 16.735 39.089 37.641h5.83c-.334-11.289-4.859-21.522-12.075-29.223h-.006Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m129.734 103.174 1.84 1.514-20.978 25.209-1.84-1.514 20.978-25.209Z",
    fill: "#010001",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m99.41 117.679-1.512 1.834 12.698 10.384 1.518-1.834-12.704-10.384Z",
    fill: "#010001",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.639 18.18h-33.891v6.74h33.891v-6.74Z",
    fill: "#3D82F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.283 4.447V35.16h27.791V10.333l-.013-5.886h-27.778Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.748 18.18 197.9 28.3l-10.152 9.624V18.18Zm33.891 0L211.581 28.3l10.058 9.624V18.18Z",
    fill: "#3585F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.639 37.924h-33.891L197.9 28.3h13.687l10.052 9.624Z",
    fill: "#3D82F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.725 23.495h1.09v-8.958h-1.09v8.958Z",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m205.267 13.846.775.766-4.311 4.278-.768-.766 4.304-4.278Z",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m209.596 18.124-.775.766-4.311-4.278.776-.766 4.31 4.278Z",
    fill: "#010001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h239v218H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoRequest);
export default __webpack_public_path__ + "static/media/DemoRequest.5dd1cc6139bc4b3b489773cc5d6cfa64.svg";
export { ForwardRef as ReactComponent };